import React, { ReactElement } from "react";
import RadioButton from "../radio-button";
import { RadioFilterInputProps } from "./filter.types";
import MultiFilterWrapper from "./multi-filter-wrapper";

const RadioFilterInput = ({
  showAllMode,
  selectedValue,
  onChange,
  showMoreText = "Show more filters",
  showFewerText = "Show fewer filters",
  options,
  showFewOptionsCount,
}: RadioFilterInputProps): ReactElement => {
  return options ? (
    <MultiFilterWrapper
      showAllMode={showAllMode}
      showMoreText={showMoreText}
      showFewerText={showFewerText}
      optionsCount={options.length}
      showFewOptionsCount={showFewOptionsCount}
      renderInputItem={(ind): ReactElement => {
        const { value, ...rest } = options[ind];
        return (
          <RadioButton
            {...rest}
            key={value}
            value={value}
            checked={selectedValue === value}
            onChange={onChange}
            _privateProps={{ isRadioGroup: true }}
          />
        );
      }}
    />
  ) : (
    <></>
  );
};

export default RadioFilterInput;
